import { render, staticRenderFns } from "./CampagnaContattiTableFilter.vue?vue&type=template&id=353a193c&"
import script from "./CampagnaContattiTableFilter.vue?vue&type=script&lang=ts&"
export * from "./CampagnaContattiTableFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports